import { useState } from "react";
import { useProfileStats } from "./hooks/useProfileStats";
import UserStats from "./components/UserStats";
import FriendsCard from "./components/FriendsCard";
import "../rightbarprofile/rightbarprofile.scss";

const Rightbarprofile = () => {
  const [open, setOpen] = useState(false);

  const { 
    followersCount, isFollowersLoading, 
    followingCount, isFollowingLoading, 
    friendsData, isFriendsLoading 
  } = useProfileStats();

  return (
    <>
      <button className="rightbarToggleBtn" onClick={() => setOpen(!open)}>
        {open ? "✖ Close" : "👤 Information"}
      </button>

      <div className={`rightbarprofile ${open ? "open" : ""}`}>
        <div className="container">
          
          <UserStats 
            followersCount={followersCount}
            isFollowersLoading={isFollowersLoading}
            followingCount={followingCount}
            isFollowingLoading={isFollowingLoading}
          />

          <FriendsCard 
            friendsData={friendsData}
            isFriendsLoading={isFriendsLoading}
          />

        </div>
      </div>
    </>
  );
};

export default Rightbarprofile;